import { gql } from '@apollo/client';

/**
 * GraphQL query for fetching communities in a specific group
 */
export const GET_COMMUNITIES_IN_GROUP = gql`
  query GetCommunitiesInGroup($communityGroupId: ID!) {
    communities(communityGroupId: $communityGroupId) {
      communities {
        id
        name
        communityGroupId
        logoUrl
        superHeroArtUrl
        optionalMetadata {
          description
          pgRating
          contentGenres
          contentStandardsUrl
          bigId
        }
        topics {
          name
          humanModerationAssignedTtlInSeconds
          maxCasesPerModerator
          humanModerationCasesSlaInSeconds
        }
        actions {
          name
          description
          deliveryType
          labels {
            labelId
            severity
          }
          policies
          operatorName
          deliverySettings {
            url
            postPayload
          }
        }
        workflowConfigurations {
          type
          topicActions {
            topicName
            actionNames
          }
          apiSettings {
            maxTps
            monthlyBudget
            costPerAudioHour
            numberOfClipsPerHour
            accessClients {
              providerUrl
              clientIdList
            }
            contentTypeTps {
              text
              image
              audio
              username
            }
          }
        }
        securityGroups {
          admin
          moderator
          user
        }
        userRole
        roles
      }
      isAdmin
    }
  }
`;
